import React, { Component } from "react";
import LocationItem from "./LocationItem";
import {
  getSucursalesClienteRegistrado,
  getSucursalesIndividual,
} from "../repository";
import Swal from "sweetalert";
//import Icon from "../images/marker-48-1.png";

class LocationItems extends Component {
  constructor() {
    super();
    this.state = {
      status: "",
      sucursales: [],
      sucursalesCliente: [],
      i: 0,
    };
  }

  getItems(idSucursal) {
    getSucursalesIndividual(idSucursal)
      .then((response) => {
        if (response.status === "success") {
         // console.log(response);
          this.setState((prevState) => ({
            status: "success",
            sucursales: [...prevState.sucursales, response.sucursales[0]], // acumula
          }));

          return response.sucursales[0];
        } else {
          this.setState({
            status: "failed",
          });
        }
      })
      .catch((error) => {
        console.log(error);

        this.setState({
          status: "failed",
        });
      });
  }

  obtieneSucursalesCliente = () => {
    var user = JSON.parse(sessionStorage.getItem("usuario"));
    var idClienteGlobal = user[0].idClienteGlobal;

    getSucursalesClienteRegistrado(idClienteGlobal)
      .then((response) => {
        if (response.status === "success") {
          this.setState({
            status: "success",
            sucursalesCliente: response.result,
          });
          var i = this.state.i;
          for (i = 0; i <= response.result.length - 1; i++) {
            this.getItems(response.result[i].iAlmacenId);
          }
        } else {
          Swal(
            "Error obtener la información [Pedidos]",
            response.message,
            "error"
          );
        }
      })
      .catch((err) =>
        Swal("Error obtener la información [Pedidos]", err, "error")
      );
  };

  componentDidMount() {
    this.obtieneSucursalesCliente();
  
  }

  onMapCreated(map) {
    map.setOptions({
      disableDefaultUI: false,
    });
  }

  render() {
    if (this.state.status === "success") {
      var sucursales = this.state.sucursales;
    }

    return (
      this.state.status === "success" && (
        <div className="row">
          {sucursales.map((item, index) => (
            <LocationItem item={item} key={index} />
          ))}
        </div>
      )
    );
  }
}

export default LocationItems;
